import React, { memo } from 'react';
import classes from './EnterButton.module.css'

export default memo((props: any) => (
    <div className={classes.enterButton}>
        
        <div style={{marginRight: '10px'}}>{props.text}</div>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
        <g fill="none" fillRule="evenodd">
            <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M10 8.00001C10 8.28838 9.87552 8.5627 9.65851 8.75259L1.65851 15.7526C1.24287 16.1163 0.611106 16.0742 0.247425 15.6585C-0.116257 15.2429 -0.0741402 14.6111 0.341497 14.2474L7.48141 8.00001L0.341496 1.75259C-0.0741414 1.38891 -0.116259 0.757147 0.247423 0.34151C0.611105 -0.0741267 1.24287 -0.116244 1.6585 0.247438L9.65851 7.24744C9.87552 7.43733 10 7.71165 10 8.00001Z" fill="black" />
        </g>
        </svg>
    </div>
))